'use strict';

var React = require('react');

var SvgOutgoingIcon = function SvgOutgoingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.22 4.03a.75.75 0 0 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22h-1.44a2.25 2.25 0 0 0-2.25 2.25v3.75a.75.75 0 0 1-1.5 0v-3.75a3.75 3.75 0 0 1 3.75-3.75h1.44l-1.22-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.25a.75.75 0 0 1 .75.75v.51a2.25 2.25 0 0 1-2.25 2.25h-8.5a2.25 2.25 0 0 1-2.25-2.25v-.51a.75.75 0 0 1 1.5 0v.51c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-.51a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgOutgoingIcon.displayName = "OutgoingIcon";

exports.SvgOutgoingIcon = SvgOutgoingIcon;
